import { HOST_DOMAIN_HONGKONG, HOST_DOMAIN_MAINLAND } from '@/const';

function getHostUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
  if (!hostName || !nodeName) {
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0);';
  }

  const hostDomain = isHongKong ? HOST_DOMAIN_HONGKONG : HOST_DOMAIN_MAINLAND;
  return `https://${hostName}${nodeName}.${hostDomain}`;
}

export default getHostUrl;
